export var FAR_TIMES = ['far', 'times'];
export var FAR_CHEVRON_UP = ['far', 'chevron-up'];
export var FAR_CHEVRON_DOWN = ['far', 'chevron-down'];
export var FAR_GLOBE = ['far', 'globe'];
export var FAR_BUILDING_COLUMNS = ['far', 'building-columns'];
export var FAR_CHECK = ['far', 'check'];
export var FAR_CREDIT_CARD = ['far', 'credit-card'];
export var FAR_LOCK_KEYHOLE = ['far', 'lock-keyhole'];
export var FAR_MONEY_BILL = ['far', 'money-bill'];
export var FAR_CIRCLE_XMARK = ['far', 'circle-xmark'];
export var FAR_CIRCLE_PLUS = ['far', 'circle-plus'];
export var FAL_ENVELOPE = ['fal', 'envelope'];
export var FAL_MESSAGE_LINES = ['fal', 'message-lines'];
export var FAL_ANGLE_DOWN = ['fal', 'angle-down'];
export var FAL_CHECK_CIRCLE = ['fal', 'check-circle'];
export var FAL_PAPER_PLANE = ['fal', 'paper-plane'];
export var FAL_SHIELD_CHECK = ['fal', 'shield-check'];
export var FAL_PHONE = ['fal', 'phone'];
export var FAS_CIRCLE_EXCLAMATION = ['fas', 'circle-exclamation'];
export var FAS_TRIANGLE_EXCLAMATION = [
    'fas',
    'triangle-exclamation'
];
export var FAS_DOLLAR_SIGN = ['fas', 'dollar-sign'];
export var FAS_ENVELOPE = ['fas', 'envelope'];
export var FAS_MESSAGE_LINES = ['fas', 'message-lines'];
export var FAS_ANGLE_DOWN = ['fas', 'angle-down'];
export var FAS_USER_CIRCLE = ['fas', 'user-circle'];
